const VIEW_ADS_PERFORMANCE = 'view_ad_performance'
const CREATE_EDIT_ADS = 'create_edit_ad'
const MANAGE_ADS_PAYMENT_METHODS = 'manage_ad_payment'

export { VIEW_ADS_PERFORMANCE, CREATE_EDIT_ADS, MANAGE_ADS_PAYMENT_METHODS }
